import { createSelector } from '@reduxjs/toolkit';
const selectVouchersState = (state) => state.vouchers;
export const selectContractVouchers = createSelector([selectVouchersState, (state, contractId) => contractId], (vouchersState, contractId) => {
    return (vouchersState.contracts[contractId] || {
        products: [],
        isLoading: false,
        isError: false,
        error: null,
        isDataFresh: false,
        lastFetchTime: null,
    });
});
export const selectContractProducts = createSelector([selectContractVouchers], contractVouchers => contractVouchers.products);
export const selectContractLoading = createSelector([selectContractVouchers], contractVouchers => contractVouchers.isLoading);
export const selectContractError = createSelector([selectContractVouchers], contractVouchers => ({
    isError: contractVouchers.isError,
    error: contractVouchers.error,
}));
export const selectContractDataFreshness = createSelector([selectContractVouchers], contractVouchers => ({
    isDataFresh: contractVouchers.isDataFresh,
    lastFetchTime: contractVouchers.lastFetchTime,
}));
export const selectShouldFetchContract = createSelector([selectContractVouchers, (state, contractId) => contractId], (contractVouchers, contractId) => {
    if (!contractId)
        return false;
    return !contractVouchers.isDataFresh;
});
export const selectAllLoadedContracts = createSelector([selectVouchersState], vouchersState => Object.keys(vouchersState.contracts));
export const selectVouchersStats = createSelector([selectVouchersState], vouchersState => {
    const contracts = Object.values(vouchersState.contracts);
    return {
        totalContracts: contracts.length,
        loadingContracts: contracts.filter(c => c.isLoading).length,
        errorContracts: contracts.filter(c => c.isError).length,
        freshContracts: contracts.filter(c => c.isDataFresh).length,
    };
});
